<template>
  <div class="clinic-work-step-wrap section-space--ptb_60 bg-gray" id="service">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-wrapper text-center section-space--pb_60">
            <h2 class="section-title font-weight--blod wow move-up">
              The correct Platform for Healthcare Providers
            </h2>
          </div>
        </div>
      </div>
      <!-- clinic Process Step first Start -->
      <div class="clinic-work-process-step">
        <div class="row">
          <div class="col-lg-7 wow move-up custom-flex">
            <div class="clinic-work-step__media images-left-ml text-center">
              <img src="/banner3.png" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-5 wow move-up">
            <div class="clinic-work-process-step__content">
              <div class="app-showcase__inner">
                <h4 class="font-weight--bold">
                  SaaS for Company's <br />
                  Back-Office Management
                </h4>
                <div class="sub-text">
                  For receptionists to manage patients profiles, perform
                  admission, and export payment.
                </div>
                <ul class="check-list green-check-list section-space--mt_20">
                  <li class="list-item">Managing patient profiles</li>
                  <li class="list-item">Booking appointment</li>
                  <li class="list-item">Admit patient into EMR system</li>
                </ul>
                <button
                  @click="useTheApp"
                  type="submit"
                  class="ht-btn ht-btn-lg mt-3"
                  style="
                    color: white;
                    border-color: white;
                    border-width: 2px;
                    width: 220px;
                    line-height: 56px;
                  "
                >
                  Using the App
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clinic-work-process-step section-space--pt_90">
        <div class="row">
          <div class="col-lg-5 order-lg-1 order-2 wow move-up">
            <div class="clinic-work-process-step__content">
              <div class="app-showcase__inner">
                <h4 class="font-weight--bold">
                  E-Commerce platform for<br />Online Sales
                </h4>
                <div class="sub-text">
                  For clinics to provide healthcare services, medicines,<br />
                  or equipment online.
                </div>
                <ul class="check-list green-check-list section-space--mt_20">
                  <li class="list-item">
                    Place sale orders
                  </li>
                  <li class="list-item">
                    Inventory management
                  </li>
                  <li class="list-item">
                    Blogs and articles
                  </li>
                  <button
                    @click="useMiniShop"
                    type="submit"
                    class="ht-btn ht-btn-lg mt-3"
                    style="
                    color: white;
                    border-color: white;
                    border-width: 2px;
                    width: 220px;
                    line-height: 56px;
                  "
                  >
                    See the Demo
                  </button>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-7 order-lg-2 order-1 wow move-up custom-flex">
            <div class="clinic-work-step__media images-right-mr text-center">
              <img src="/h1.png" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
        </div>
      </div>
      <div class="clinic-work-process-step section-space--pt_90">
        <div class="row">
          <div class="col-lg-7 wow move-up custom-flex">
            <div class="clinic-work-step__media images-left-ml text-center">
              <img src="/h3.png" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-5 wow move-up">
            <div class="clinic-work-process-step__content">
              <div class="app-showcase__inner">
                <h4 class="font-weight--bold">
                  In-House Medical Devices<br />and Health Insights
                </h4>
                <div class="sub-text">
                  For doctors to perform medical examination right on the
                  browser and monitor patients from home.
                </div>
                <ul class="check-list green-check-list section-space--mt_20">
                  <li class="list-item">
                    Blood pressure device
                  </li>
                  <li class="list-item">
                    Urinal flow device
                  </li>
                  <li class="list-item">
                    Holter ECG device
                  </li>
                  <button
                    @click="bookMeeting"
                    type="submit"
                    class="ht-btn ht-btn-lg mt-3"
                    style="
                    color: white;
                    border-color: white;
                    border-width: 2px;
                    width: 220px;
                    line-height: 56px;
                  "
                  >
                    Book a Demo
                  </button>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- clinic Process Step Three End -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ClinicWorkStep",
  methods: {
    useTheApp() {
      window.open("https://his.sandrasoft.app");
    },
    useMiniShop() {
      window.open("https://shop.sandrasoft.app");
    },
    bookMeeting() {
      window.open("https://calendly.com/nichealpham/experiment1et");
    },
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .col-lg-5.custom-flex {
    flex: 0 0 48.666667%;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 48.6667%;
    max-width: 48.666667%;
  }
}
</style>
